var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.721,
    height: 20.499,
    viewBox: "0 0 16.721 20.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(-3.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(3.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M17.178,21.649H5.842A2.687,2.687,0,0,1,3.15,18.973V5.826A2.687,2.687,0,0,1,5.842,3.15H7.732a.8.8,0,1,1,0,1.6H5.842a1.084,1.084,0,0,0-1.086,1.08V18.973a1.084,1.084,0,0,0,1.086,1.08H17.178a1.084,1.084,0,0,0,1.086-1.08V5.826a1.084,1.084,0,0,0-1.086-1.08H15.289a.8.8,0,1,1,0-1.6h1.889a2.687,2.687,0,0,1,2.692,2.676V18.973A2.687,2.687,0,0,1,17.178,21.649Z",
    transform: "translate(-3.15 -1.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    d: "M.813-.85H6.207A1.766,1.766,0,0,1,7.871,1V3A1.766,1.766,0,0,1,6.207,4.85H.813A1.766,1.766,0,0,1-.85,3V1A1.766,1.766,0,0,1,.813-.85Zm5.394,4A.143.143,0,0,0,6.342,3V1A.143.143,0,0,0,6.207.85H.813A.143.143,0,0,0,.678,1V3a.143.143,0,0,0,.135.15Z",
    transform: "translate(4.85 0.85)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTransparent);
export default __webpack_public_path__ + "static/media/clipboard-transparent.c63b5a1e1dedaec975e1d718f6bfd8b1.svg";
export { ForwardRef as ReactComponent };